import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=1ea2eaf3&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports